module.exports = __webpack_public_path__ + "static/img/doge-word-art.b37f18b9.png";